import get from 'lodash/get'

/* eslint no-underscore-dangle: 0 */
export const createProjectApproverList = (list) => {
  const temp = []
  if (list !== undefined) {
    list.map(approver => {
      if (!get(approver, 'is_system_admin')) {
        temp.push({
          label: `${approver.emp_code} - ${approver.first_name} ${approver.last_name} (${approver.nick_name})`,
          name: `${approver.first_name} ${approver.last_name}`,
          value: approver._id,
          _id: approver._id,
        })
      }
      return approver
    })
  }
  return temp
}
export const createPMSupervisorList = (list) => {
  const temp = []
  if (list !== undefined) {
    list.map(approver => {
      if (!get(approver, 'is_system_admin') && ((get(approver, 'level') === 'VP' || get(approver, 'level') === 'Director') || get(approver, 'level') === 'Asst. VP')) {
        temp.push({
          label: `${approver.emp_code} - ${approver.first_name} ${approver.last_name} (${approver.nick_name})`,
          name: `${approver.first_name} ${approver.last_name}`,
          value: approver._id,
          _id: approver._id,
        })
      }
      return approver
    })
  }
  return temp
}
export const createProjectManagerList = (list) => {
  const temp = []
  if (list !== undefined) {
    list.map(approver => {
      if (!get(approver, 'is_system_admin')
      && (get(approver, 'is_pm_role') || get(approver, 'is_project_approver_role'))) {
        temp.push({
          label: `${approver.emp_code} - ${approver.first_name} ${approver.last_name} (${approver.nick_name})`,
          name: `${approver.first_name} ${approver.last_name}`,
          value: approver._id,
          _id: approver._id,
          is_project_approver_role: approver.is_project_approver_role,
        })
      }
      return approver
    })
  }
  return temp
}



// WEBPACK FOOTER //
// ./src/components/project-information/helper/project.js